
export default "/assets/superscript.febcd153.svg"